var render = function render(){var _vm=this,_c=_vm._self._c;return _c('roles-table',{attrs:{"headers":_vm.headers,"roles":_vm.roles},on:{"deleteRole":function($event){return _vm.deleteRole($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }